import { useSelector } from '../../hooks/usePrerenderUser';
import {
  RenderProofExperience,
  resolveRenderProofExperience,
} from './RenderProofExperience';

/**
 * Buckets on the **account**, not the login.
 *
 * `/me` exposes the dashboard login as `id` and the account as `companyId`.
 * Everything this experiment measures is account-level — the domain is verified
 * once per account, the proof is generated from that account's cached render,
 * and activation is counted per account — so bucketing on the login would put
 * two colleagues on one account into different arms and split the conversion
 * they jointly produced.
 */
export function useRenderProofExperience(): RenderProofExperience {
  const accountId = useSelector((state) => state.prerenderUser.companyId);
  return resolveRenderProofExperience(accountId);
}
